/* eslint-disable */

import * as clientService from "../services/httpsClient";

export const getSales = async (accessToken, params) => {
  try {
    const domain = `sales`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportExcel = async (accessToken, params) => {
  try {
    const domain = `sales/export-excel`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};
